export default __webpack_public_path__ + "static/media/(58).cb777e34.jpg";